import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagBuenContribuidorFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagBuenContribuidor'>
      {({ field }) => (
        <Form.Checkbox
          {...field}
          checked={iValue}
          disabled={fIsSubmitting}
          id='checkbox-flagBuenContribuidor'
          label='Es buen contribuidor'
        />
      )}
    </Field>
  )
}

export default FlagBuenContribuidorFormGroup
